/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import AutorenewIcon from "@material-ui/icons/Autorenew";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openEditProjectPage, allowEdit, openManageProjectPage }
) => (
  <>
    {allowEdit && (
      <OverlayTrigger
        overlay={<Tooltip id="project-edit-tooltip">Edit Project</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
          onClick={() => openEditProjectPage(row.uuid)}
        >
          {row.id}
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    )}

    <> </>
    <OverlayTrigger
      overlay={<Tooltip id="products-delete-tooltip">Kelola Projek </Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-info btn-sm"
        onClick={() => openManageProjectPage(row.uuid)}
      >
        <span className="svg-icon svg-icon-md svg-icon-info">
          <AutorenewIcon />
          {/* <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} /> */}
        </span>
      </a>
    </OverlayTrigger>
  </>
);
